import classNames from 'classnames';

import type { FC, HTMLAttributes, ReactNode } from 'react';

import styles from './Badge.module.scss';

type Props = HTMLAttributes<HTMLSpanElement> & {
  children?: ReactNode;
  variant?: 'grey' | 'green';
  small?: boolean;
};

const Badge: FC<Props> = ({
  children,
  variant = 'grey',
  small = false,
  ...props
}) => {
  if (!children) {
    return null;
  }

  return (
    <span
      className={classNames(styles.badge, {
        [styles.grey]: variant === 'grey',
        [styles.green]: variant === 'green',
        [styles.small]: small,
      })}
      {...props}
    >
      {children}
    </span>
  );
};

export { Badge };
